<template>
    <div style="height: 50px;margin-top: -1px;">
        <el-card
            :class="this.$route.params.actione_type === 'edit' ? this.$store.getters.current_footer === '' ? 'footer_add' : this.$store.getters.current_footer : 'footer_add'"
            style="height:">
            <el-form label-width="100px">
                <div style="text-align: center;">
                    <el-button size="Medium" :loading="loading" icon="el-icon-success" type="primary" @click="submit"
                        v-show="$route.params.actione_type === 'V' ? false : true" :disabled="disabled" >
                        <span v-if="!loading">
                            {{
                                edit_name || $t("_save")
                            }}
                        </span>
                        <span v-else>{{ $t("_saveing") }}</span>
                    </el-button>
                    <slot name="addiButton"></slot>
                    <el-button size="Medium" icon="el-icon-close" @click="exit">
                        <span>
                            {{
                                $t("_exit")
                            }}
                        </span>
                    </el-button>
                </div>
            </el-form>
        </el-card>
        <!--只針對新增、編輯頁增加返回頂部顯示-->
        <div v-if="this.IsMobile() != null">
            <Backtotop :visibility-height="300" :back-position="250" :class_name="'el-card'" />
        </div>
        <div v-else>
            <el-tooltip placement="top" content="返回頂部">
                <Backtotop :visibility-height="300" :back-position="250" :class_name="'el-card'" />
            </el-tooltip>
        </div>
    </div>
</template>
<script>
import Backtotop from '@/components/backtotop/Index.vue'
export default {
    //name: 'footer',
    components: { Backtotop },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        create_name: {
            type: String,
            default: ""
        },
        create_date: {
            type: String,
            default: ""
        },
        edit_name: {
            type: String,
            default: ""
        },
        edit_date: {
            type: String,
            default: ""
        },
        void_name: {
            type: String,
            default: ""
        },
        void_date: {
            type: String,
            default: ""
        },
        auto_exit: {
            type: Boolean,
            default: false
        },
        form_disabled: {
            type: Boolean,
            default: false
        },
        edit_disabled: {
            type: Boolean,
            default: false
        },
        delete_disabled: {
            type: Boolean,
            default: false
        },
        resume_disabled: {
            type: Boolean,
            default: false
        },
        actione_type: {
            type: String,
            default: ""
        },
        active: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            
        };
    },
    methods: {
        // 保存
        submit() {
            this.$emit('click');
        },
        // 退出
        exit() {
            this.$emit('close');
        },
        // 编辑
        ready_edit() {
            this.$emit('ready_edit');
        },
        // 刪除
        handleDel() {
            this.$emit('delete');
        },
        // 恢復
        handleResume() {
            this.$emit('resume');
        },
    },
    mounted() {
        this.SetFontSize(this.$store.getters.size);
    },
    // 父頁面值發生變化時(父子都需要使用sync同時响应)
    computed: {
        // 是否自动退出
        current_auto_exit: {
            get() {
                return this.auto_exit
            },
            set(val) {
                this.$emit('update:auto_exit', val)
            }
        },
        // 是否禁啟用表單
        current_form_disabled: {
            get() {
                return this.form_disabled
            },
            set(val) {
                this.$emit('update:form_disabled', val)
            }
        },
        // 是否禁啟用編輯按鈕
        current_edit_disabled: {
            get() {
                return this.edit_disabled
            },
            set(val) {
                this.$emit('update:edit_disabled', val)
            }
        },
        // 是否禁啟用刪除按鈕
        current_delete_disabled: {
            get() {
                return this.delete_disabled
            },
            set(val) {
                this.$emit('update:delete_disabled', val)
            }
        },
        // 是否禁啟用恢復按鈕
        current_resume_disabled: {
            get() {
                return this.resume_disabled
            },
            set(val) {
                this.$emit('update:resume_disabled', val)
            }
        },
        // 是否删除
        current_active: {
            get() {
                return this.active
            },
            set(val) {
                this.$emit('update:active', val)
            }
        },
    },
}
</script>
<style lang="less" scoped>
// 适配手机端按钮太大换行
.el-button {
    width: 78px; //86px--適配最小手機寬度
    // 避免樣式覆蓋問題
    position: relative;
    z-index: 1;
    padding: 12px 0px; //適配按鈕圖標縮進
}
</style>